'use client'

import React, { useContext, useEffect, useRef, useState } from 'react'

import { ResizeContext } from '../../../apps/storefront/src/context/resize-context'

interface SimpleAccordionProps {
  children: React.ReactNode | React.ReactNode[]
  isOpen: boolean
  refreshKey?: any // Change this to recalculate the height
}

export const SimpleAccordion = ({
  children,
  isOpen,
  refreshKey,
}: SimpleAccordionProps) => {
  const [height, setHeight] = useState('0px')
  const contentRef = useRef<HTMLDivElement>(null)
  const windowSize = useContext(ResizeContext)

  useEffect(() => {
    updateHeight()
  }, [refreshKey])

  const updateHeight = () => {
    if (contentRef.current) {
      setHeight(isOpen ? `${contentRef.current.scrollHeight}px` : '0px')
    }
  }

  useEffect(() => {
    updateHeight()
  }, [isOpen, windowSize])

  return (
    <div
      className="overflow-hidden transition-all duration-500 ease-in-out"
      style={{ maxHeight: height }}
    >
      <div ref={contentRef} className="overflow-hidden">
        {children}
      </div>
    </div>
  )
}
